module.exports = __webpack_public_path__ + "static/media/instruction.18e84da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/postcard/instruction.png
// module id = 329
// module chunks = 0